import { useEffect, useState } from "react";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";

function AdminPopupList() {

  const [popups, setPopups] =
    useState([]);

  const navigate =
    useNavigate();

  const loadPopups =
    async () => {

      try {

        const res =
          await API.get(
            "/popups"
          );

        setPopups(
          res.data
        );

      }

      catch(error) {

        console.log(error);

      }

    };

  useEffect(() => {

    loadPopups();

  }, []);

  const deletePopup =
    async (id) => {

      if(
        !window.confirm(
          "Supprimer ce popup ?"
        )
      ) return;

      try {

        await API.delete(
          `/popups/${id}`
        );

        loadPopups();

      }

      catch(error) {

        console.log(error);

      }

    };

  const publishPopup =
    async (id) => {

      try {

        await API.put(

          `/popups/${id}`,

          {
            status:
              "published"
          }

        );

        loadPopups();

      }

      catch(error) {

        console.log(error);

      }

    };

  const draftPopup =
    async (id) => {

      try {

        await API.put(

          `/popups/${id}`,

          {
            status:
              "draft"
          }

        );

        loadPopups();

      }

      catch(error) {

        console.log(error);

      }

    };

  return (

    <div className="admin-popup-list">

      <div className="popup-header">

        <h1>
          Gestion des Popups
        </h1>

        <button

          onClick={() =>
            navigate(
              "/admin/popups/new"
            )
          }

        >

          ➕ Nouveau Popup

        </button>

      </div>

      <table>

        <thead>

          <tr>

            <th>Titre</th>

            <th>Audience</th>

            <th>Statut</th>

            <th>Début</th>

            <th>Fin</th>

            <th>Actions</th>

          </tr>

        </thead>

        <tbody>

          {popups.map(
            popup => (

            <tr
              key={popup._id}
            >

              <td>
                {popup.title}
              </td>

              <td>
                {popup.audience}
              </td>

              <td>

                <span

                  className={
                    popup.status
                  }

                >

                  {popup.status}

                </span>

              </td>

              <td>

                {
                  popup.startDate

                  ?

                  new Date(
                    popup.startDate
                  ).toLocaleString()

                  :

                  "-"

                }

              </td>

              <td>

                {
                  popup.endDate

                  ?

                  new Date(
                    popup.endDate
                  ).toLocaleString()

                  :

                  "∞"

                }

              </td>

              <td>

                <button

                  onClick={() =>
                    navigate(
                      `/admin/popups/edit/${popup._id}`
                    )
                  }

                >

                  ✏️

                </button>

                <button

                  onClick={() =>
                    publishPopup(
                      popup._id
                    )
                  }

                >

                  🚀

                </button>

                <button

                  onClick={() =>
                    draftPopup(
                      popup._id
                    )
                  }

                >

                  💾

                </button>

                <button

                  onClick={() =>
                    deletePopup(
                      popup._id
                    )
                  }

                >

                  🗑️

                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  );

}

export default AdminPopupList;